export default __webpack_public_path__ + "static/media/redo-icon-gray.bc9c9a93.svg";